import { ActionHeader, StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import { useEffect, useState } from "react";
import Modal from "@/common/elements/Modal";
import Table from "@/common/elements/Table";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import CommonDatePicker from "@/common/elements/DatePicker";
import { StyledFlagInformation } from "../styles";
import { useSelector } from "react-redux";
import { getFullAddress } from "@/util/common_function";

const FlagInformationDetails = ({ flagDetailsSource, associates }) => {
  const { bookings } = useSelector((state) => state?.bookings);
  // Use the provided flagDetailsSource if available; otherwise, use bookings.bio[0]
  const initialBioData = associates ? flagDetailsSource : bookings?.bio?.[0];
  const [bioData, setBioData] = useState(initialBioData);
  const [bioAddress, setBioAddress] = useState([]);
  const [bioAliases, setBioAliases] = useState([]);

  useEffect(() => {
    // Whenever the prop or redux data changes, update the local state.
    if (associates) {
      setBioData(flagDetailsSource);
    } else {
      setBioData(bookings?.bio?.[0]);
    }
  }, [flagDetailsSource, bookings]);

  useEffect(() => {
    // Build the addresses list based on the current bioData.
    let address = bioData?.bioAddresses;
    address = address?.map((a) => ({
      ...a,
      type: a?.addresses?.[0]?.addressType || "",
      fullAddress: getFullAddress(a?.addresses?.[0]),
    }));
    setBioAddress(address);
    setBioAliases(bioData?.bioAliases);
  }, [bioData]);

  const flagInformationDetailsTable = {
    headers: [
      { key: "type", text: "Type" },
      { key: "fullAddress", text: "Full Address" },
    ],
    rows: bioAddress,
  };

  const flagInformationDetailsAliasTable = {
    headers: [
      { key: "lName", text: "Last Name" },
      { key: "fName", text: "First Name" },
      { key: "mName", text: "Middle Name" },
      { key: "dob", text: "Date of Birth" },
      { key: "ssn", text: "SSN" },
      { key: "suffix", text: "Suffix" },
      { key: "questionedIdentity", text: "Questioned Identity" },
    ],
    rows: bioAliases,
  };

  return (
    <StyledFlagInformation>
      <StyledGridRow gutter={16}>
        <StyledGridCol span={5}>
          <label className="info-label">Last</label>
          <div className="info-value">{bioData?.lName}</div>
        </StyledGridCol>
        <StyledGridCol span={5}>
          <label className="info-label">First</label>
          <div className="info-value">{bioData?.fName}</div>
        </StyledGridCol>
        <StyledGridCol span={5}>
          <label className="info-label">Middle</label>
          <div className="info-value">{bioData?.mName}</div>
        </StyledGridCol>
        <StyledGridCol span={5}>
          <label className="info-label">Suffix</label>
          <div className="info-value">{bioData?.suffix}</div>
        </StyledGridCol>
      </StyledGridRow>
      <StyledGridRow gutter={16}>
        <StyledGridCol span={2}>
          <label className="info-label">Race</label>
          <div className="info-value">{bioData?.race}</div>
        </StyledGridCol>
        <StyledGridCol span={2}>
          <label className="info-label">Sex</label>
          <div className="info-value">{bioData?.sex}</div>
        </StyledGridCol>
        <StyledGridCol span={2}>
          <label className="info-label">Height</label>
          <div className="info-value">{bioData?.height}</div>
        </StyledGridCol>
        <StyledGridCol span={2}>
          <label className="info-label">Weight</label>
          <div className="info-value">{bioData?.weight}</div>
        </StyledGridCol>
      </StyledGridRow>
      <StyledGridRow gutter={16}>
        <StyledGridCol span={6}>
          <label className="info-label">Social Security Number</label>
          <div className="info-value">{bioData?.ssn}</div>
        </StyledGridCol>
        <StyledGridCol span={6}>
          <label className="info-label">Driver's License # / State</label>
          <div className="info-value">
            {bioData?.dlNumber} / {bioData?.dlState}
          </div>
        </StyledGridCol>
        <StyledGridCol span={4}>
          <label className="info-label">DOB</label>
          <div className="info-value">{bioData?.dob}</div>
        </StyledGridCol>
        <StyledGridCol span={4}>
          <label className="info-label">Age at Entry</label>
          <div className="info-value">{bioData?.ageAtEntry}</div>
        </StyledGridCol>
      </StyledGridRow>
      <label className="info-label" style={{ marginTop: "15px" }}>
        Address info
      </label>
      <Table
        headers={flagInformationDetailsTable.headers}
        data={flagInformationDetailsTable.rows}
        style={{ marginTop: "15px" }}
      />

      <label className="info-label" style={{ marginTop: "15px" }}>
        Alias info
      </label>
      <Table
        headers={flagInformationDetailsAliasTable.headers}
        data={flagInformationDetailsAliasTable.rows}
        style={{ marginTop: "15px" }}
      />
    </StyledFlagInformation>
  );
};

export default FlagInformationDetails;
